const defaultState = {
  data: [],
  callParams: {},
  loading: false,
  error: false,
};

const assignedSites = function (state = defaultState, action) {
  switch (action.type) {
    case "SET_ASSIGNED_SITES":
      return { ...state, data: action.data };

    case "SET_ASSIGNED_SITES_CALL_PARAMS":
      return { ...state, callParams: action.data };

    case "SET_ASSIGNED_SITES_LOADING":
      return {
        ...state,
        loading: action.data,
      };

    case "SET_ASSIGNED_SITES_ERROR":
      return {
        ...state,
        error: action.data,
      };

    default:
      return state;
  }
};

export default assignedSites;
